import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useContext, useState, useRef, useCallback, useEffect, useMemo, createContext } from 'react';
import Portal from '../../../../portal/index.js';
import { uid } from 'react-uid';
import { Toast } from './Toast.js';
import { Container } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Context = /*#__PURE__*/createContext({
  addToast: function addToast() {}
});
var useToast = function useToast() {
  var context = useContext(Context);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
function ToastProvider(props) {
  var children = props.children;
  var _useState = useState([]),
    toasts = _useState[0],
    setToasts = _useState[1];
  var toastTimeoutsRef = useRef([]);
  var removeToast = useCallback(function (id) {
    setToasts(function (currentToasts) {
      return currentToasts.map(function (toast) {
        if (toast.id === id) {
          return Object.assign(Object.assign({}, toast), {
            visible: false
          });
        }
        return toast;
      });
    });
  }, []);
  useEffect(function () {
    var toastTimeoutsRefCurrent = toastTimeoutsRef.current;
    return function () {
      toastTimeoutsRefCurrent.forEach(function (timeout) {
        return clearTimeout(timeout);
      });
    };
  }, []);
  var addToast = useCallback(function (value) {
    var id = uid(toasts);
    var toast = Object.assign({
      id: id
    }, value);
    var _value$timeout = value.timeout,
      timeout = _value$timeout === void 0 ? 6000 : _value$timeout,
      action = value.action;
    var newToast = Object.assign(Object.assign({}, toast), {
      timeout: timeout,
      action: action,
      visible: true
    });
    setToasts(function (currentToasts) {
      var visible = currentToasts.filter(function (t) {
        return t.visible;
      });
      return [].concat(visible, [newToast]);
    });
    if (!action) {
      var toastTimeout = window.setTimeout(function () {
        removeToast(id);
      }, timeout);
      toastTimeoutsRef.current.push(toastTimeout);
    }
  }, [toasts, removeToast]);
  var context = useMemo(function () {
    return {
      addToast: addToast
    };
  }, [addToast]);
  return /*#__PURE__*/jsxs(Context.Provider, {
    value: context,
    children: [children, /*#__PURE__*/jsx(Portal, {
      children: /*#__PURE__*/jsx(Container, {
        flexDirection: "column",
        gap: "sm",
        children: toasts.map(function (_a) {
          var id = _a.id,
            toast = __rest(_a, ["id"]);
          return /*#__PURE__*/jsx(Toast, _extends({
            onClose: function onClose() {
              return removeToast(id);
            }
          }, toast), id);
        })
      })
    })]
  });
}

export { ToastProvider, useToast };
